import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { Locale } from "@/Common/Models/Localization/Locale";

interface IUnitComponentProps {
    units: number[];
    selectedUnit: number;
    onUnitChange: (unit: number) => void;
    readonly?: boolean;
    acceptableLocales?: Locale[];
    useAbbreviation?: boolean;
}

abstract class BaseUnitComponent extends BaseReactComponent<IUnitComponentProps> {
    protected abstract get unitLabels(): { [unit: number]: string };
    protected abstract get readonlyUnitLabels(): { [unit: number]: string };

    public componentDidMount(): void {
        if (this.props.acceptableLocales?.any())
            this.setAcceptableLocales(this.props.acceptableLocales);
    }

    public render(): JSX.Element {
        const selectedUnit = this.props.selectedUnit;
        const units = this.props.units;

        if (this.props.readonly)
            return (
                <p className="text-center">
                    ({this.getString(this.readonlyUnitLabels[selectedUnit]).toLocaleLowerCase()})
                </p>
            );

        return (
            <div className="unit-header">
                <div className="unit margin-auto">
                    {units.any() && this.renderUnit(units[0])}
                    {units.slice(1).map(unit => [
                        <span key={`${unit} separator`} className="separator">|</span>,
                        this.renderUnit(unit)
                    ])}
                </div>
            </div>
        );
    }

    private renderUnit(unit: number): JSX.Element {
        return (
            <a
                key={unit}
                onClick={() => unit !== this.props.selectedUnit && this.props.onUnitChange(unit)}
                className={this.props.selectedUnit === unit ? "selected" : ""}
            >
                {this.getString(this.unitLabels[unit])}
            </a>
        );
    }
}

export { BaseUnitComponent };
